export class CommonSrRequest<T, H = SiebelMessage<T>> {
  body: CommonApiBody<T, H> = new CommonApiBody<T, H>();
}
export class CommonApiBody<T, H> {
  "DCMethod"? = "SAVEASDRAFT";
  "DCLoginName"? = "";
  "DCLanguage"="ENU";
  ProcessName = 'DC Create Update SR Web WF';
  SiebelMessage?: SiebelMessage<T>;
  DCIncomingHierarchy?: H;
}

export class SiebelMessage<T> {
  xmlns = 'http://www.siebel.com/xml/DC%20Query%20Member%20Info';
  MessageId = '';
  MessageType = 'Integration Object';
  IntObjectName = "";
  IntObjectFormat = 'Siebel Hierarchical';
  // dynamic object where root key (like "ListOfDC SR Information Service") can vary
  [key: string]: any | T;

  // This method is used to initialize the class instance using initial data
  constructor(initialData?: Partial<SiebelMessage<T>>) {
    Object.assign(this, initialData);
  }
}

export interface HierarchyWrapper<T> {
  MessageId: string;
  IntObjectName: string;
  MessageType: string;
  IntObjectFormat: string;
  [key: string]: any | T; // allows dynamic root object like ListOfXYZ
}